export default __webpack_public_path__ + "static/media/BX.2e6ceb08.png";